"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconOpenEye = function IconOpenEye(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconOpenEye', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fill: "#999CA1",
    fillRule: "evenodd",
    d: "M8 2c2.253 0 4.226 1.088 5.903 2.877.576.615 1.077 1.271 1.5 1.928.257.397.433.71.527.897a.667.667 0 0 1 0 .596c-.094.188-.27.5-.526.897a13.661 13.661 0 0 1-1.501 1.928C12.226 12.912 10.253 14 8 14c-2.253 0-4.226-1.088-5.903-2.877a13.661 13.661 0 0 1-1.5-1.928C.34 8.798.163 8.485.07 8.298a.667.667 0 0 1 0-.596c.094-.188.27-.5.526-.897.424-.657.925-1.313 1.501-1.928C3.774 3.088 5.747 2 8 2zm0 1.333c-1.83 0-3.483.912-4.93 2.456A12.342 12.342 0 0 0 1.427 8a12.342 12.342 0 0 0 1.643 2.21c1.447 1.545 3.1 2.457 4.93 2.457 1.83 0 3.483-.912 4.93-2.456A12.342 12.342 0 0 0 14.573 8a12.342 12.342 0 0 0-1.643-2.21C11.483 4.244 9.83 3.332 8 3.332zm0 2a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334zm0 1.334a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666z"
  }));
};

var _default = IconOpenEye;
exports.default = _default;